import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/Index.vue'
import ScreenplayEditor from '@/views/ScreenplayEditor.vue'
import SceneEditor from '@/views/SceneEditor.vue'
import PageNotFound from '@/views/error/PageNotFound.vue'
import homeRoutes from './home'
Vue.use(VueRouter)

let routes = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/game',
    name: 'game',
    component: () => import(
      /* webpackChunkName: "game-dev" */
      /* webpackMode: "lazy" */
      '@/views/NewGame.vue'
    )
  },
  {
    path: '/game/dev',
    name: 'game-dev',
    component: () => import(
      /* webpackChunkName: "game-dev" */
      /* webpackMode: "lazy" */
      '@/views/NewGameDev.vue'
    )
  },
  {
    path: '/newgame',
    redirect: '/game'
  },
  {
    path: '/newgame/dev',
    redirect: '/game/dev'
  },
  {
    path: '/screenplay/:sid?',
    name: 'screenplay-view',
    component: () => import(
      /* webpackChunkName: "screenplay-view" */
      /* webpackMode: "lazy" */
      '@/views/ScreenplayView.vue'
    )
  },
  {
    path: '/screenplay/history/:recordId',
    name: 'history-demo',
    component: () => import(
      /* webpackChunkName: "history-demo" */
      /* webpackMode: "lazy" */
      '@/views/HistoryDemo.vue'
    )
  },
  // 編輯相關
  {
    path: '/edit',
    name: 'editor-screenplay',
    component: ScreenplayEditor
  },
  {
    path: '/edit/scene',
    name: 'editor-scene',
    component: SceneEditor
  },
  {
    path: '/game/dashboard',
    name: 'game-dashboard',
    component: () => import(
      /* webpackChunkName: "game-dashboard" */
      /* webpackMode: "lazy" */
      '@/views/Dashboard.vue'
    )
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(
      /* webpackChunkName: "about" */
      /* webpackMode: "lazy" */
      '@/views/About.vue'
    )
  },
  {
    path: '/sim',
    name: 'action-sim',
    component: () => import(
      /* webpackChunkName: "action-sim" */
      /* webpackMode: "lazy" */
      '@/views/ActionSim.vue'
    )
  },
  {
    path: '/albums/',
    name: 'albums',
    component: () => import(
      '@/views/album/Index.vue'
    )
  },
  {
    path: '/demo/records',
    name: 'demo-records',
    component: () => import(
      /* webpackChunkName: "demo-records" */
      /* webpackMode: "lazy" */
      '@/views/demo/DemoRecordView.vue'
    )
  },
  {
    path: '/demo/0327',
    name: 'demo-0327',
    component: () => import(
      /* webpackChunkName: "demo-0327" */
      /* webpackMode: "lazy" */
      '@/views/demo/Demo0327.vue'
    )
  },
  {
    path: '/demo/0327/dev',
    name: 'demo-0327-dev',
    component: () => import(
      /* webpackChunkName: "demo-0327-dev" */
      /* webpackMode: "lazy" */
      '@/views/demo/Demo0327Dev.vue'
    )
  },
  {
    path: '*',
    name: 'error-404',
    component: PageNotFound
  }
]

routes = routes.concat(homeRoutes)

// true  => web page mode
// false => assistant mode

const withoutIFrame = window.parent === window
const router = new VueRouter({
  mode: withoutIFrame ? 'history' : 'abstract',
  routes
})
console.debug(`new vue router & mode=${withoutIFrame ? 'history' : 'abstract'}`)

export default router
